
import { mapActions, mapGetters, mapState } from 'vuex'
import { WcsNewsletter } from '@/scripts/libs/wcs/newsletter'
import { required, email } from 'vuelidate/lib/validators'
import md5 from 'md5'
import sha from 'sha.js'
import { TRACKER_ERROR_SOURCE_SERVER, TRACKER_SUBMIT_NEWSLETTER } from '@/scripts/constants/tracker'
import { Cookies } from '@/scripts/libs/cookies'
import wcs from '@/scripts/libs/wcs'
import { ALREADY_SIGNED } from '@/scripts/constants/cookies'
import { RB_FIELDROW__HELPER, RB_FOOTER__MAIL } from '../constants/css-classes'
import {
  ACTION_INCREMENT_NEWSLETTER_COUNTER,
  ACTION_LOAD_MINICART,
  ACTION_LOAD_MINIWISHLIST,
} from '../store/actions'
import { MOBILE, TABLET } from '@/scripts/constants/media-query'
import { WcsEarlyAccess } from '../libs/wcs/early-access'
import { EarlyAccess } from '../libs/early-access'

export default {
  name: 'rb-footer-mail',
  data() {
    return {
      email: '',
      stateForm: WcsNewsletter.FORM_STATES_INIT,
      FORM_STATES_INIT: WcsNewsletter.FORM_STATES_INIT,
      FORM_STATES_OK: WcsNewsletter.FORM_STATES_OK,
      FORM_STATES_KO: WcsNewsletter.FORM_STATES_KO,
      FORM_STATES_LOADING: WcsNewsletter.FORM_STATES_LOADING,
      FORM_STATES_WARNING: WcsNewsletter.FORM_STATES_WARNING,
      activateFocusInput: false,
      validationBypass: true,
      helperLabel: '',
    }
  },
  validations: {
    email: {
      required,
      email,
    },
  },
  computed: {
    ...mapGetters(['translation']),
    ...mapState({
      orderId: (state) => state.sidebar.cart.details.orderId,
    }),
    formLoading() {
      return this.stateForm === WcsNewsletter.FORM_STATES_LOADING
    },
    formLanded() {
      return (
        this.stateForm === WcsNewsletter.FORM_STATES_INIT ||
        this.stateForm === WcsNewsletter.FORM_STATES_WARNING
      )
    },
    formSuccess() {
      return this.stateForm === WcsNewsletter.FORM_STATES_OK
    },
    formFail() {
      return this.stateForm === WcsNewsletter.FORM_STATES_KO
    },
    formClasses() {
      return {
        'rb-fieldrow': true,
        'rb-emptyrow':
          !this.validationBypass && this.$v.email.$dirty && this.$v.email.$model === '',
        'rb-validrow':
          !this.validationBypass &&
          this.$v.email.$dirty &&
          !this.$v.email.$invalid &&
          this.stateForm !== WcsNewsletter.FORM_STATES_WARNING,
        'rb-invalidrow':
          !this.validationBypass && this.$v.email.$dirty && this.$v.email.$invalid
            ? // eslint-disable-next-line vue/no-side-effects-in-computed-properties
              (this.helperLabel = this.translation('common.email_invalid_format'))
            : this.stateForm === WcsNewsletter.FORM_STATES_WARNING,
        'rb-floating': this.$v.email.$model.length,
      }
    },
    mailPolicyClasses() {
      return {
        'rb-footer__mail__policy--visible': this.activateFocusInput,
      }
    },
    helperClasses() {
      return {
        'rb-fieldrow__helper--display': this.stateForm === WcsNewsletter.FORM_STATES_WARNING,
      }
    },
    isMobile() {
      return this.$mq === MOBILE || this.$mq === TABLET
    },
    emailLowercase() {
      return this.email.toLowerCase()
    },
  },
  watch: {
    email(value) {
      this.email = value?.toLowerCase()
    },
  },
  mounted() {
    const footerMail = document.getElementsByClassName(RB_FOOTER__MAIL)[0]
    if (footerMail) {
      const alreadySignedCookie = Cookies.get(ALREADY_SIGNED)
      if (alreadySignedCookie) {
        footerMail.classList.add('hidden')
      }
    }
  },
  methods: {
    ...mapActions({
      incrementNewsletterCounter: ACTION_INCREMENT_NEWSLETTER_COUNTER,
      loadCart: ACTION_LOAD_MINICART,
      loadMiniWishlist: ACTION_LOAD_MINIWISHLIST,
    }),
    async submit() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        try {
          this.stateForm = WcsNewsletter.FORM_STATES_LOADING
          const result = await WcsNewsletter.submitNewsletterRegistration(this.$v.email.$model)
          this.stateForm = result.stateForm
          if (this.stateForm === WcsNewsletter.FORM_STATES_WARNING) {
            this.helperLabel = this.translation(`common.${result.cause}`)
          }
          if (this.stateForm === WcsNewsletter.FORM_STATES_OK) {
            Cookies.set(ALREADY_SIGNED, true)
            const { earlyAccess } = wcs.getStoreConfig()
            if (earlyAccess.active) {
              sessionStorage.setItem('promoCodeToApplyEvaluateQuery', 'eaccess')
              EarlyAccess.checkAndWriteEarlyAccessCookie()
              await WcsEarlyAccess.callEarlyAccess(this.orderId, async () => {
                this.incrementNewsletterCounter()
                await this.loadCart()
                await this.loadMiniWishlist()
              })
              if (!wcs.isInPdp()) {
                window.location.reload()
              }
            }
          }
          this.$ma.trackEvent({
            event: TRACKER_SUBMIT_NEWSLETTER,
            value: {
              User_Email_MD5: md5(this.emailLowercase),
              User_Email_SHA256: sha('sha256').update(this.emailLowercase).digest('hex'),
            },
          })
        } catch (e) {
          this._vm.$ma.trackException({
            source: TRACKER_ERROR_SOURCE_SERVER,
            code: e,
            detail: e.message,
          })
        }
      } else {
        const errorMessage = document.getElementsByClassName(RB_FIELDROW__HELPER)[0]
        errorMessage.focus()
      }
    },
  },
}
